export default __webpack_public_path__ + "static/media/rocky.e9778964.jpg";